export default "__VITE_ASSET__CtbR3IQn__"